let csrfToken: string | null = null;

export const csrfTokenManager = {
  clearToken: () => {
    csrfToken = null;
  },
  getToken: () => csrfToken,
  setToken: (token: string) => {
    csrfToken = token;
  },
};
